import { render } from "./myFooter.vue?vue&type=template&id=536d87ad&scoped=true&ts=true"
import script from "./myFooter.vue?vue&type=script&lang=ts"
export * from "./myFooter.vue?vue&type=script&lang=ts"

import "./myFooter.vue?vue&type=style&index=0&id=536d87ad&lang=less&scoped=true"

import exportComponent from "E:\\pc\\saas-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536d87ad"]])

export default __exports__